import { Filters } from "../types"
import { getApiClient } from "../client"
import {
  Notification,
  NotificationResponse,
  NotificationCountResponse,
} from "../types/notifications"

export const getFilteredStudentNotifications = async (data: Filters) => {
  const apiClient = getApiClient()

  return await apiClient
    .post<NotificationResponse>("notifications/filters", { json: data })
    .json()
}

export const markNotificationAsRead = async (
  notificationId: Notification["id"],
) => {
  const apiClient = getApiClient()

  return await apiClient
    .post<NotificationResponse>(`notifications/${notificationId}/read`)
    .json()
}

export const getNotificationCount = async () => {
  const apiClient = getApiClient()

  return await apiClient
    .get<NotificationCountResponse>("notifications/unread_count")
    .json()
}
